import { getFormattedLinkToBrowser } from '~/utils/url';

export const GENERAL_CONDITIONS_LINK = getFormattedLinkToBrowser(
  'https://psffiles.blob.core.windows.net/psfcontratos/termos/seguros/assurant/bolsa-protegida/condicoes-gerais-contratacao.pdf'
);
